import React from 'react';
import PropTypes from 'prop-types';
import EsignLandingPageRadioButtons from './EsignLandingPageRadioButtons';
import EsignLandingPagePhotoToPDFModal from './EsignLandingPagePhotoToPDFModal';

const EsignLandingPageFullWidthUploadPanel = props => (
  <div className="large-upload-panel-upload-section-wrapper">
    <div className="upload-wrap edit-pages-upload-wrap hide-for-photos">
      <form id="dropzoneUploader" className="uploader">
        <div className="alert alert-error uploader-error">Error</div>
        <div
          className="uploader-area edit-pages-uploader-area"
          onDrop={() => { window._track('Edit PDF Landing Page', 'Drag and Drop Upload Zone'); }}
        >
          <img
            src="/images/blue-doc-icon.png"
            alt="Document and Arrow Icon"
            className="large-upload-panel-document-icon"
          />
          <h3 className="large-upload-panel-header">Drag and Drop Your File Here</h3>
          <p className="large-upload-panel-sub-header">{props.subHeader}</p>
          <a
            id="uploadPDFLarge"
            className="btn btn-success large-upload-panel-cta-button"
          >
            Upload a File to Edit
          </a>
          <EsignLandingPageRadioButtons />
        </div>
      </form>
    </div>
    <EsignLandingPagePhotoToPDFModal />
  </div>
);

EsignLandingPageFullWidthUploadPanel.defaultProps = {
  subHeader: 'PDF or Word Document',
};

EsignLandingPageFullWidthUploadPanel.propTypes = {
  subHeader: PropTypes.string,
};

export default EsignLandingPageFullWidthUploadPanel;



// WEBPACK FOOTER //
// ./src-react/EsignLandingPage/EsignLandingPageFullWidthUploadPanel.jsx